import { createFileRoute } from '@tanstack/react-router';

import { SkuRulesPage, skuRulesQueryOptions } from '@/features/dictionary';

export const Route = createFileRoute('/_authed/_active/org/catalog-setup/sku-rules/')({
  loader: ({ context }) =>
    context.queryClient
      .query({ ...skuRulesQueryOptions(), staleTime: 'static' })
      .catch(() => undefined),
  component: SkuRulesPage,
});
